import { createSelector } from '@reduxjs/toolkit'

import { selectState } from '../selectState'

export const selectExportPptx = createSelector(selectState, (state) => state.exportPptx)
